import { Toaster } from 'sonner';

import { useToastNotifications } from '@/hooks/useToastNotifications';

import styles from './styles.module.css';

// Vertical space between two toasts once the stack expands on hover.
const TOAST_GAP = 12;

const NotificationToaster: React.FC = () => {
  useToastNotifications();
  return <Toaster position="top-right" gap={TOAST_GAP} className={styles.toasterRoot} />;
};

export { NotificationToaster };
